import { Entity, GetEntitiesResponse } from '../core/entities/entity.model';

export const ENTITIES_GET_ENDPOINT = '/api/servicios_fijos/v1/users';

export const ENTITIES_MULTIPLE: Entity[] = [
  {
    id: '1',
    commercialName: 'COMMERCIAL NAME TEST1',
    channelType: 'I',
    documentNumber: '12345689',
    isEmployee: false,
  },
  {
    id: '2',
    commercialName: 'COMMERCIAL NAME TEST2',
    channelType: 'I',
    documentNumber: '234567890',
    isEmployee: false,
  },
  {
    id: '3',
    commercialName: 'COMMERCIAL NAME TEST3',
    channelType: 'I',
    documentNumber: '345678901',
    isEmployee: true,
  },
];

export const ENTITIES_SINGLE: Entity[] = [
  {
    id: '1',
    commercialName: 'COMMERCIAL NAME TEST1',
    channelType: 'D',
    documentNumber: '123456789',
    isEmployee: false,
  },
];

export const ENTITIES_OK_MULTIPLE_REPLY: GetEntitiesResponse = {
  activity: 'D',
  entities: ENTITIES_MULTIPLE,
  debtAuthorized: true,
};

export const ENTITIES_OK_SINGLE_REPLY: GetEntitiesResponse = {
  activity: 'D',
  entities: ENTITIES_SINGLE,
  debtAuthorized: true,
};
